export class LocalStorageService {
    constructor() {}
    /**
     * Save data to localStorage
     * @param key Storage key
     * @param value Data to store (any type)
     */
    setItem<T>(key: string, value: T): void {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        } catch (error) {
            return error;
        }
    }

    /**
     * Retrieve data from localStorage
     * @param key Storage key
     * @returns Parsed data or null if not found
     */
    getItem<T>(key: string): T | null {
        try {
            const value = localStorage.getItem(key);
            return value ? (JSON.parse(value) as T) : null;
        } catch (error) {
            return error;
        }
    }

    /**
     * Remove item from localStorage
     * @param key Storage key
     */
    removeItem(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            return error;
        }
    }

    /**
     * Clear all items from localStorage
     */
    clear(): void {
        try {
            localStorage.clear();
        } catch (error) {
            return error;
        }
    }

    /**
     * Check if a key exists in localStorage
     * @param key Storage key
     * @returns boolean
     */
    hasItem(key: string): boolean {
        return localStorage.getItem(key) !== null;
    }
}
